import { render, staticRenderFns } from "./RulesTableWrapper.vue?vue&type=template&id=11a47b89&scoped=true"
import script from "./RulesTableWrapper.vue?vue&type=script&lang=js"
export * from "./RulesTableWrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11a47b89",
  null
  
)

export default component.exports